import React from "react";

import { Skeleton } from "../skeleton";
import * as styles from "./chat-item-skeleton.css";

interface ChatItemSkeletonProps {
  "data-testid"?: string;
}

export const ChatItemSkeleton: React.FC<ChatItemSkeletonProps> = ({
  "data-testid": dataTestId = "chat-item-skeleton"
}) => {
  return (
    <div className={styles.item} data-testid={dataTestId}>
      {/* Avatar */}
      <div className={styles.avatar} data-testid={`${dataTestId}-avatar`}>
        <Skeleton circle width="48px" height="48px" />
      </div>

      {/* Content */}
      <div className={styles.content} data-testid={`${dataTestId}-content`}>
        {/* Username row */}
        <div className={styles.header} data-testid={`${dataTestId}-header`}>
          <Skeleton width="120px" height="20px" />
          <Skeleton width="60px" height="16px" />
        </div>

        {/* Badge row */}
        <div className={styles.footer} data-testid={`${dataTestId}-footer`}>
          <Skeleton width="100px" height="24px" />
        </div>
      </div>
    </div>
  );
};

export default ChatItemSkeleton;
